function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "sparkle"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4 5.08a.5.5 0 01.95 0l.52 1.4a4.05 4.05 0 002.4 2.4l1.4.52a.5.5 0 010 .95l-1.4.52a4.05 4.05 0 00-2.4 2.4l-.52 1.4a.5.5 0 01-.95 0l-.52-1.4a4.05 4.05 0 00-2.4-2.4l-1.4-.52a.5.5 0 010-.95l1.4-.52a4.05 4.05 0 002.4-2.4l.52-1.4z",
  fill: "url(#paint0_linear_192_3333)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.4 1.26a.4.4 0 01.76 0l.26.7c.2.55.64.98 1.2 1.19l.68.25a.4.4 0 010 .76l-.69.26c-.55.2-.99.64-1.2 1.2l-.25.68a.4.4 0 01-.76 0l-.25-.69c-.2-.55-.64-.99-1.2-1.2l-.69-.25a.4.4 0 010-.76l.7-.25c.55-.2.98-.64 1.19-1.2l.25-.69z",
  fill: "url(#paint1_linear_192_3333)"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_192_3333",
  x1: "1",
  y1: "1",
  x2: "13",
  y2: "13.75",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EF8200"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_192_3333",
  x1: "1",
  y1: "1",
  x2: "13",
  y2: "13.75",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EF8200"
}))));